export interface Meal {
  type: MealType;
  mealPercentage: number;
  localSeasonalPercent: number;
  scheduledDays?: number[];
  foodImpactDetail?: {
    impact: number;
  };
}
export enum MealType {
  Vegetarian = 'vegetarian',
  Flexitarian = 'flexitarian',
  ClassicWithRedMeat = 'classicWithRedMeat',
  ClassicWithWhiteMeat = 'classicWithWhiteMeat',
  ClassicWithFish = 'classicWithFish',
  VariedMeals = 'variedMeals',
  VegetarianDehydratedMeals = 'vegetarianDehydratedMeals',
  DehydratedMeals = 'dehydratedMeals',
  RedMeatDehydratedMeals = 'redMeatDehydratedMeals',
}
